import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useSnackbar } from "notistack";

export const ListCustomDistribution = (resultHandler, enqueueSnackbar) => {
  let getAPI = "/api/distribution";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071/api/distribution";
  }
  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        response
          .text()
          .then((text) => {
            throw Error(response.statusText + ": " + text);
          })
          .catch((error) =>
            enqueueSnackbar(error.message, { variant: "error" })
          );
      } else {
        response.json().then((parsedResponse) => resultHandler(parsedResponse));
      }
    })
    .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
};

function DialogCustomDistribution({ open, onCancel, onFinish }) {
  const [distributions, setDistributions] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (open === true) {
      ListCustomDistribution((result) => {
        const newDistributions = result.map((distribution) => {
          return { id: distribution.id, name: distribution.name };
        });
        setDistributions(newDistributions);
      }, enqueueSnackbar);
    }
  }, [enqueueSnackbar, open]);

  const distributionListItems = distributions.map((distribution) => {
    return (
      <ListItem
        button
        onClick={() => {
          onFinish(distribution.id);
        }}
        key={distribution.id}
      >
        <ListItemText primary={distribution.name} />
      </ListItem>
    );
  });

  const close = () => {
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title"
      scroll="paper"
    >
      <DialogTitle id="form-dialog-title">Select Distribution</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>Please choose a distribution:</DialogContentText>
        <List>{distributionListItems}</List>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCustomDistribution;
